import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import Button from '../../components/Button';
import api from '../../services/api';
import { useAlert } from '../../hooks/useAlert';

import ImageSelectVerificationMethod from '../../assets/verify-account-select-verification-method.svg';
import ImageVerifyAccountEmail from '../../assets/verify-account-email.png';
import ImageVerifyAccountSms from '../../assets/verify-account-sms.png';

import { VerifyAccountContainer, SelectVerificationMethod } from './styles';

function VerifyAccount() {
  const history = useHistory();
  const { Alerts, handleAlert } = useAlert();

  const [ verificationMethod, setVerificationMethod ] = useState<"sms" | "email">("email");
  const [ userId, setUserId ] = useState<string>();

  useEffect(() => {
    const user_id = new URLSearchParams(window.location.search).get('user_id');

    if (!user_id) {
      history.push('/');
      return
    }

    setUserId(user_id);
  }, [history]);

  function handleChange(e: React.FormEvent) {
    const 
      verificationSelect = e.target as HTMLElement,
      verificationType = verificationSelect.dataset.verification as "sms" | "email" | undefined,
      notification = new Audio('/assets/songs/change.mp3')
    ;

    if (!verificationType) return alert('Error on select');
    
    if (verificationType !== verificationMethod) {
      setVerificationMethod(verificationType);
  
      notification.play();
    }
  }

  async function handleSubmit() {
    const uri = `account-confirmation/${verificationMethod}/${userId}`;

    const response = await api.get(uri)
      .then(response => response && response.data)
      .catch(err => console.error(err))
    ;

    if (!response) return handleAlert(400, 'Error', 'Ops, ocorreu um erro ao enviar o código de verificação, tente novamente mais tarde.')

    history.push('/verify-account/enter-code');
  }

  return (
    <VerifyAccountContainer>
      <SelectVerificationMethod>
        <img 
          src={ImageSelectVerificationMethod} 
          alt="Escolha o método de verificação" 
        />

        <div className="heading">
          <h1>Verifique sua conta</h1>
  
          <p>
            Agora falta muito pouco, escolha abaixo um método para verificar sua conta.
          </p>
        </div>

        <div className="verification-methods-selects">
          <div 
            className={`
              verification-method 
              email 
              ${verificationMethod === 'email' && 'active'}
            `}
            data-verification="email"
            onClick={handleChange}
          >
            <div>
              <i className="fas fa-check-circle" />
              <img src={ImageVerifyAccountEmail} alt="Verificar conta por e-mail" />
              <strong>E-mail</strong>
            </div>
          </div>

          <div 
            className={`
              verification-method 
              sms 
              ${verificationMethod === 'sms' && 'active'}
            `}
            data-verification="sms"
            onClick={handleChange}
          >
            <div>
              <i className="fas fa-check-circle" />
              <img src={ImageVerifyAccountSms} alt="Verificar conta por e-mail" />
              <strong>SMS</strong>
            </div>
          </div>
        </div>

        <Button onClick={handleSubmit}>
          Continuar
        </Button>
      </SelectVerificationMethod>

      <Alerts />
    </VerifyAccountContainer>
  );
};

export default VerifyAccount;
